<template>
  <div>
    <portal to="headerBreadCrumb">
      <div class="flex h-full items-center">
        <div class="flex items-center" v-if="funnel && funnel.name">
          <div class="cursor-pointer text-grey-500" @click="sendToFunnels" v-tooltip="'Back to Funnels'">
            <arrow-bracket-icon class="h-5 w-5 fill-current"/>
          </div>
          <div class="text-sm ml-3">{{ funnel.name }}</div>
          <chevron-right-icon class="h-5 w-5 fill-current"/>
          <div class="text-sm mr-2">{{ $t('frontend_affiliate_promos_affiliate_dashboard') }}</div>
        </div>
      </div>
    </portal>
    <funnel-settings-drawer v-if="settingsOpen && funnel" :funnel="funnel" @close="settingsOpen = false" @saved="settingsSaved" />
    <p v-if="settingsSuccess" class="gs-funnel-dashboard__saved" role="status">Funnel settings saved.</p>
    <div class="gs-funnel-dashboard">
      <v-wait for="funnel_loading">
        <funnel-studio v-if="funnel" :funnel="funnel" @settings="settingsOpen = true" />
        <div v-else-if="loadFailed" class="gs-funnel-dashboard__error" role="alert">
          <h1>We couldn’t load this funnel.</h1>
          <p>Please try again.</p>
          <button type="button" @click="loadFunnel">Try again</button>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
import Funnel from '@/models/Funnel';
import FunnelStudio from './components/FunnelStudio.vue';
import FunnelSettingsDrawer from './index-partials/FunnelSettingsDrawer.vue';
import ArrowBracketIcon from '@/assets/images/icons/ArrowBracketIcon.svg';
import ChevronRightIcon from '@/assets/images/icons/ChevronRightIcon.svg';

export default {
  middleware: 'auth',
  metaInfo() { return { title: this.$t('funnel_dashboard') }; },
  components: { FunnelSettingsDrawer, FunnelStudio, ArrowBracketIcon, ChevronRightIcon },
  data() { return { funnel: null, loadFailed: false, settingsOpen: false, settingsSuccess: false }; },
  created() { this.loadFunnel(); },
  methods: {
    settingsSaved(funnel) { this.funnel = funnel; this.settingsOpen = false; this.settingsSuccess = true; },
    async loadFunnel() {
      this.loadFailed = false;
      this.$wait.start('funnel_loading');
      try { this.funnel = await Funnel.$find(this.$route.params.id); }
      catch (error) { this.loadFailed = true; }
      finally { this.$wait.end('funnel_loading'); }
    },
    sendToFunnels() { this.$router.push({ name: 'funnels' }); },
  },
};
</script>

<style scoped>
.gs-funnel-dashboard__saved { margin:16px 28px; padding:12px 18px; border:1px solid #B9DFCE; background:#EAF9F0; color:#226348; border-radius:8px; }
.gs-funnel-dashboard { width:100%; padding:0 28px; }
.gs-funnel-dashboard__error { max-width:600px; margin:40px auto; padding:28px; background:#FFF; border-radius:14px; }
.gs-funnel-dashboard__error button { margin-top:16px; padding:12px 18px; background:#263456; color:#FFF; border-radius:8px; }
@media (max-width:600px) { .gs-funnel-dashboard { padding:0 16px; } }
</style>
